import { Tooltip } from '@frekuent/orbit/components';
import { Info } from '@/legacy/components/ui/Icons';

type ColumnHeaderTooltipProps = {
	tooltipText: string;
};

const ColumnHeaderTooltip = ({ tooltipText }: ColumnHeaderTooltipProps) => {
	return (
		<Tooltip content={tooltipText}>
			<span
				className='inline-flex items-baeline justify-center cursor-helper h-[14px] w-[14px]'
				onClick={(e) => e.stopPropagation()}
			>
				<Info
					width={14}
					height={14}
				/>
			</span>
		</Tooltip>
	);
};

export default ColumnHeaderTooltip;
